<template>
    <svg class="icon" :class="'icon--' + name" aria-hidden="true" role="presentation">
        <use :xlink:href="'#' + name"></use>
    </svg>
</template>

<script>
export default {
    props: {
        name: String,
    },
};
</script>

<style lang="scss">
.icon {
    display: inline-block;
    position: relative;
    width: 1.8rem;
    height: 1.8rem;
    fill: currentColor;
    top: 0.3ex;
}
</style>
